import { useEffect, useRef } from 'react'
import { useMenuOnSession } from '@/components/layout/MainMenuOnSessionProvider'
import { MediaModal } from '@/components/pbo/MediaModal'
import { useParsedQuery } from '@/hooks/useParsedQuery'
import { MenuStorage } from '@/utils/storage/MenuStorage'
import { INBOUND_WORK_SEARCH_MENU_CODE } from '@/services/global/inboundWorkSearch/consts'
import InboundWorkSearchPage from './page.generated'
import {
  bindInboundWorkSearchPersist,
  closeMedia,
  fromSearchQuery,
  initInboundWorkSearchStore,
  saveSearchLists,
  toUrlQuery,
  useMediaState,
  withSavedLists,
} from './wiring'

/**
 * GL10 입고작업조회 2.0(GL18) — 화면은 컨덕터 생성본(page.generated.tsx), 배선은 wiring.ts (LOGISPRD-16038).
 * 조회 전용이다. 1.0 GL10(iframe)은 그대로 두고 새 메뉴코드로 나란히 올린다.
 * 첨부·동영상은 생성본의 DS 모달(파일 이름만) 대신 공용 MediaModal 을 열람 전용으로 띄운다(RGR02 선례).
 */
export default function InboundWorkSearch() {
  const { parsedQs, replaceQuery } = useParsedQuery<Record<string, unknown>>()
  // reload 는 useCallback 이라 참조가 고정이다. 컨텍스트 값 객체는 Provider 렌더마다 새로 만들어진다.
  const { reload: reloadMenuSession } = useMenuOnSession()
  // 모듈 상태(조회 조건·모달 대상)는 첫 렌더 전에 정한다. 다른 메뉴에 다녀오면 URL 에 실어 둔 조건으로 다시 조회하고,
  // 탭을 닫았다 다시 열면 URL 이 비어 빈 화면에서 시작한다(GI17 LOGISPRD-17344 선례).
  // 진입 한 번만 URL 을 읽는다. 진입 뒤에는 [조회] 가 조건을 정하고 URL 은 그 결과를 따라 적을 뿐이다.
  const initialized = useRef(false)
  if (!initialized.current) {
    initialized.current = true
    initInboundWorkSearchStore(withSavedLists(fromSearchQuery(parsedQs)))
  }
  useEffect(() => {
    bindInboundWorkSearchPersist((req) => {
      // 입고송장번호 목록은 URL 한도 때문에 sessionStorage 에 따로 둔다(wiring saveSearchLists)
      saveSearchLists(req)
      const query = req ? toUrlQuery(req) : {}
      MenuStorage.menuOnSession.setSearch(query)
      replaceQuery(query)
      reloadMenuSession()
    })
    return () => bindInboundWorkSearchPersist(null)
  }, [reloadMenuSession, replaceQuery])
  const media = useMediaState()
  return (
    <>
      <InboundWorkSearchPage />
      <MediaModal
        menuCode={INBOUND_WORK_SEARCH_MENU_CODE}
        open={Boolean(media.target)}
        kind={media.target?.kind ?? null}
        row={media.target?.row ?? null}
        shipper={media.target?.shipper ?? ''}
        filesByFileId={media.filesByFileId}
        readOnly
        onClose={closeMedia}
      />
    </>
  )
}
